export const refinery = [
  {
    name: "IRPC",
    latitude: 12.662371,
    longitude: 101.308277,
    imageUrl: "assets/refinery/icon_irpc.png",
  },
  {
    name: "SPRC",
    latitude: 12.6554,
    longitude: 101.15805,
    imageUrl: "assets/refinery/icon_sprc.png",
  },
  {
    name: "PTTGC",
    latitude: 12.663066,
    longitude: 101.151199,
    imageUrl: "assets/refinery/icon_ptt.png",
  },
  {
    name: "ESSO",
    latitude: 13.092048,
    longitude: 100.890554,
    imageUrl: "assets/refinery/icon_esso.png",
  },
  {
    name: "BCP",
    latitude: 13.683667,
    longitude: 100.591601,
    imageUrl: "assets/refinery/icon_bcp.png",
  },
  {
    name: "TOP",
    latitude: 13.12374,
    longitude: 100.8814,
    imageUrl: "assets/refinery/icon_top.png",
  },
  {
    name: "CENTER",
    latitude: 13.7772995,
    longitude: 100.5255274,
    imageUrl: "assets/logo/logo.png",
  },
];
